import axios from 'axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const WebsocketService = {
    echo: null,

    init: async function () {
        this.echo = new Echo({
            broadcaster: 'pusher',
            key: `${import.meta.env.VITE_PUSHER_APP_KEY}`,
            wsHost: `${import.meta.env.VITE_PUSHER_HOST}`,
            wsPort: `${import.meta.env.VITE_PUSHER_PORT}`,
            wssPort: `${import.meta.env.VITE_PUSHER_PORT}`,
            forceTLS: false,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: `${import.meta.env.VITE_PUSHER_APP_CLUSTER}`,
            authorizer: (channel) => {
                return {
                    authorize: (socketId, callback) => {
                        axios
                            .post('/api/websocket/auth', {
                                socket_id: socketId,
                                channel_name: channel.name,
                            })
                            .then((response) => {
                                callback(false, response.data);
                            })
                            .catch((error) => {
                                callback(true, error);
                            });
                    },
                };
            },
            withoutInterceptors: true,
        });
    },

    getPresenceChannel(channelName) {
        return this.echo.join(channelName);
    },

    getPrivateChannel(channelName) {
        return new Promise((resolve, reject) => {
            const channel = this.echo.private(channelName);
            if (channel.subscription.subscribed) {
                return resolve(channel);
            }
            channel.subscription.bind('pusher:subscription_succeeded', () => {
                return resolve(channel);
            });
        });
    },

    getPublicChannel(channelName) {
        return new Promise((resolve, reject) => {
            const channel = this.echo.channel(channelName);
            if (channel.subscription.subscribed) {
                return resolve(channel);
            }
            channel.subscription.bind('pusher:subscription_succeeded', () => {
                return resolve(channel);
            });
        });
    },
};

export default WebsocketService;
